export default __webpack_public_path__ + "static/media/gallery-wip-emitter_06.ef650668.jpg";